import React, { useEffect } from 'react';
import { FormGroup, Input, Label } from 'reactstrap';

const CheckListNumbers = ({
  checkList,
  selectedItem,
  isNumberModify,
  setSelectedNumbers,
  selectedNumbers,
  selectedList,
}) => {
  const numbers = isNumberModify ? selectedNumbers : selectedList;
  const handleCheckPress = e => {
    if (!isNumberModify) {
      selectedItem(e.target);
    }
    if (isNumberModify) {
      if (selectedNumbers?.find(item => item === e.target.value)) {
        const numberList = selectedNumbers?.filter(item => item !== e.target.value);
        setSelectedNumbers(numberList);
      } else {
        setSelectedNumbers([...selectedNumbers, e.target.value]);
      }
    }
  };

  useEffect(() => {
    setSelectedNumbers(checkList?.map(item => item?._id || item?.numRef));
  }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', paddingLeft: '20px' }}>
      {checkList.map((item, index) => {
        return (
          <FormGroup>
            <Label check>
              <Input
                type="checkbox"
                checked={numbers?.includes(item?._id || item?.numRef)}
                index={index}
                value={item?._id || item.numRef}
                onChange={handleCheckPress}
              />
              {item.number}
            </Label>
          </FormGroup>
        );
      })}
    </div>
  );
};
export default CheckListNumbers;
